import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Header from "@/components/Header";
import bridge from "@/config/JSbridge";
import smoothscroll from "smoothscroll-polyfill";
import h5Share from "@/utils/h5Share";
import bwmodel from "@/config/bwmodel";
import OpenApp from "../../components/OpenApp";
import { jumpTo, userBehaver } from "../../utils";
import { Base64 } from "js-base64/base64.js";
import { connect } from 'react-redux';
const App = ({userId}) => {
  const active_id = 172;
  const [count, setCount] = useState(0);
  const isStorm = bwmodel.app === "storm";
  useEffect(() => {
    document.title = "市值风云开户专属福利活动";
    h5Share.main({
      title: `牛市来了，新开户享投资升级服务 `,
      desc: "开户就送Level-2+风云VIP+投资三件套，把握机会，牛市不等人！",
      link: process.env.REACT_APP_DEMAND_URL + "active_" + active_id,
      thumbUrl: "https://file.wogoo.com/app/logo/logo6.png",
      wxShare: {
        shareData: {
          imgUrl: "https://file.wogoo.com/app/logo/logo6.png",
        },
      },
      shareData: {
        imgUrl: "https://file.wogoo.com/app/logo/logo6.png",
      },
    });
    smoothscroll.polyfill();
    
    userBehaver({
      activeIdKey: "Activity_View",
      conId: active_id,
      userId: userId,
      active_id: `8401`,
      time: new Date()
    });
  }, []);
  useEffect(() => {
    let num = localStorage.getItem("count" + active_id);
    if (num !== null) {
      num++;
      console.log(num);

      localStorage.setItem("count" + active_id, num);
      setCount(num);
    } else {
      localStorage.setItem("count" + active_id, count);
    }
  }, []);
  useEffect(() => {
    var elements = document.querySelectorAll("[url]");
    elements.forEach((element) => {
      element.onclick = (e) => {
        const url = e.target.getAttribute("url");
        jumpTo(url);
        const conId = e.target.getAttribute("data-conId");
        if (conId) {
          userBehaver({
            activeIdKey: "Activity_Start",
            // conId: conId,
             conId: active_id,
            userId: userId,
            active_id: `8402`,
            time: new Date()
          });
        }
      };
    });
  }, []);
  // {id: 'd981a1a300ea497d910476b2ad4e8e0e', type: 0, title: '市值风云券商开户客服'},
  // `storm://app/multi/im/sessionDetails?sessionId=d981a1a300ea497d910476b2ad4e8e0e&sessionType=0&nickname=市值风云券商开户客服`
  const handleLeftClick = () => {
    bridge.callHandler(
      "nativeEvent",
      {
        event: "close",
        params: {
          isDelete: false,
        },
      },
      () => {},
    );
    // }
  };
  const x5ContainWebUrl = (url) => {
    return `storm://app/x5ContainWeb?url=${Base64.encode(url)}`;
  };

  // const handleSecuritiesClick = (brokerName) => {
  //   userBehaver({
  //     activeIdKey: "Activity_Start",
  //     conId: `8402`,
  //     userId: userId,
  //     active_id: active_id,
  //     con_ext: brokerName,
  //     time: new Date()
  //   });
  // };

  return (
    <div>
      {isStorm && (
        <Header
          title={"市值风云开户专属福利活动"}
          leftClick={() => {
            handleLeftClick();
          }}
          hideNaviBar
          right={
            bwmodel.compareVersion("4.17.9") ? (
              <img
                onClick={() => {
                  bridge.callHandler("nativeEvent", {
                    event: "shareLink",
                    params: {
                      // shareLinkParams:{
                      title: `牛市来了，新开户享投资升级服务`,
                      desc: "开户就送Level-2+风云VIP+投资三件套，把握机会，牛市不等人！",
                      thumbUrl: "https://file.wogoo.com/app/logo/logo6.png",
                      linkUrl: process.env.REACT_APP_DEMAND_URL + "active_172",
                    },
                  });
                }}
                style={{ width: "20px", "vertical-align": "middle" }}
                src={
                  bwmodel.theme === "0"
                    ? require(`@/img/share.png`)
                    : require(`@/img/share_dark.png`)
                }
                alt="分享"
              />
            ) : (
              ""
            )
          }
        />
      )}

      <Container style={isStorm ? {} : { paddingTop: "20px" }}>
        <div>
          {count % 4 === 0 ? (
            <img src={require(`./images/1@2x.png`)} alt="" />
          ) : count % 4 === 1 ? (
            <img src={require(`./images/2@2x.png`)} alt="" />
          ) : count % 4 === 2 ? (
            <img src={require(`./images/3@2x.png`)} alt="" />
          ) : (
            <img src={require(`./images/4@2x.png`)} alt="" />
          )}
          <img
            style={{ margin: "10px 0px" }}
            src={require(`./images/3件套@2x.png`)}
            alt=""
          />

          <div style={{ margin: "0px 10px" }}>
            <img src={require(`./images/专属投资工具@2x.png`)} alt="" />
            <div className="box box_1">
              <div className="card_box">
                <div className="img_wrapper">
                  <img
                    url="storm://app/user/memberInfoDetails?spuId=2"
                    src={require(`./images/研报畅读@2x.png`)}
                    alt=""
                  />
                  <img
                    url="storm://app/user/memberInfoDetails?spuId=3"
                    src={require(`./images/吾股排名@2x.png`)}
                    alt=""
                  />
                </div>
                <div className="img_wrapper">
                  <img
                    url="storm://app/user/memberInfoDetails?spuId=26"
                    src={require(`./images/短线挖掘@2x.png`)}
                    alt=""
                  />
                  <img
                    url="storm://app/user/memberInfoDetails?spuId=22"
                    src={require(`./images/吾股复盘@2x.png`)}
                    alt=""
                  />
                </div>
                <div className="img_wrapper">
                  <img
                    url="storm://app/user/memberInfoDetails?spuId=23"
                    src={require(`./images/红绿波段@2x.png`)}
                    alt=""
                  />
                  <img
                    url="storm://app/user/memberInfoDetails?spuId=27"
                    src={require(`./images/趋势拐点@2x.png`)}
                    alt=""
                  />
                </div>
                <div className="img_wrapper">
                  <img
                    url="storm://app/user/memberInfoDetails?spuId=24"
                    src={require(`./images/跳空异动@2x.png`)}
                    alt=""
                  />
                  <img
                    url="storm://app/user/memberInfoDetails?spuId=25"
                    src={require(`./images/一阳指@2x.png`)}
                    alt=""
                  />
                </div>
                <div className="img_wrapper">
                  <img
                    url="storm://app/user/memberInfoDetails?spuId=32"
                    src={require(`./images/筹码洞察@2x.png`)}
                    alt=""
                  />
                  <img
                    url="storm://app/user/memberInfoDetails?spuId=28"
                    src={require(`./images/大鳄周边@2x.png`)}
                    alt=""
                  />
                </div>
                <div className="img_wrapper">
                  <img
                    url="storm://app/user/memberInfoDetails?spuId=30"
                    src={require(`./images/估值挖掘机@2x.png`)}
                    alt=""
                  />
                  <img
                    url="storm://app/user/memberInfoDetails?spuId=31"
                    src={require(`./images/易融术@2x.png`)}
                    alt=""
                  />
                </div>
                <div className="img_wrapper">
                  <img
                    url="storm://app/user/memberInfoDetails?spuId=5"
                    src={require(`./images/锦鲤卡@2x.png`)}
                    alt=""
                  />
                  <img
                    url="storm://app/stockDealModule/stockDealHome"
                    src={require(`./images/付费直播@2x.png`)}
                    alt=""
                  />
                </div>
                <div className="img_wrapper">
                  <img
                    url="https://f10.wogoo.com/#/answers/stock"
                    src={require(`./images/大鳄问股@2x.png`)}
                    alt=""
                  />
                  <img
                    url="storm://app/marketQuotations/allWatchRemind"
                    src={require(`./images/盯盘提醒@2x.png`)}
                    alt=""
                  />
                </div>
              </div>
              <div className="line"></div>
              <div className="tips">
                <img src={require(`./images/限时加码福利@2x.png`)} alt="" />
                <div>
                  开户即送<span>「投资进阶三件套」</span>，目前剩余{" "}
                  <span>99</span> 份{" "}
                </div>
              </div>

              <div className="card_box2">
                <div className="img_wrapper">
                  <img
                    url="https://www.wogoo.com/activity/active_146"
                    src={require(`./images/福利笔记@2x.png`)}
                    alt=""
                  />
                </div>
                <div className="img_wrapper">
                  <img
                    url="https://www.wogoo.com/essay/#/?articleId=2d211bf62d4f47f7b6937cce7270f88b&articleType=1"
                    src={require(`./images/福利全景图@2x.png`)}
                    alt=""
                  />
                </div>
                <div className="img_wrapper">
                  <img
                    url="https://www.wogoo.com/activity/active_150"
                    src={require(`./images/福利地图@2x.png`)}
                    alt=""
                  />
                </div>
              </div>
            </div>

            <div>
              <img
                style={{ marginTop: "10px" }}
                src={require(`./images/券商投资升级@2x.png`)}
                alt=""
              />
            </div>
            <div className="box">
              <img
    
                data-conId="8402"
                url={x5ContainWebUrl(
                  "https://kaihu.gyzq.com.cn:1443/guoyuan-stkkh-hvue/views/index.html?channel_no=4564#/index",
                )}
                src={require(`./images/国元证券@2x.png`)}
                alt=""
              />
          
            
            </div>
            <div>
              <img
                style={{ marginTop: "10px" }}
                src={require(`./images/如何领取@2x.png`)}
                alt=""
              />
            </div>

            <div className="box">
              <img src={require(`./images/编组44@2x.png`)} alt="" />
              <div className="line"></div>
              <img src={require(`./images/编组 45@2x.png`)} alt="" />
              <div style={{ margin: "15px 0" }}>
                <img
                  url="storm://app/multi/im/sessionDetails?sessionId=d981a1a300ea497d910476b2ad4e8e0e&sessionType=0&nickname=市值风云券商开户客服"
                  src={require(`./images/开户客服@2x.png`)}
                  alt=""
                />
              </div>

              <img src={require(`./images/券商领取步骤@2x.png`)} alt="" />
            </div>
            <img
              style={{ marginTop: "10px" }}
              src={require(`./images/开户奖励@2x.png`)}
              alt=""
            />
            <div className="box box_2">
              <img
                url="https://www.wogoo.com/activity/active_42"
                src={require(`./images/image18.png`)}
                alt=""
              />
            </div>
            <img
              style={{ marginTop: "10px" }}
              src={require(`./images/答疑@2x.png`)}
              alt=""
            />
            <div className="box">
              <img src={require(`./images/答疑一@2x.png`)} alt="" />
              <div className="line"></div>
              <img
                style={{ marginBottom: "10px" }}
                src={require(`./images/答疑二@2x.png`)}
                alt=""
              />
            </div>
            {!isStorm && (
              <OpenApp
                style={{ marginBottom: "20px" }}
                url={`${process.env.REACT_APP_DEMAND_URL}active_172`}
              ></OpenApp>
            )}
            {/* <img src={require(`./images/平安证券xia@2x.png`)} alt=""/> */}
            <img
              className="kefu"
              url="storm://app/multi/im/sessionDetails?sessionId=d981a1a300ea497d910476b2ad4e8e0e&sessionType=0&nickname=市值风云券商开户客服"
              src={require(`./images/客服@2x.png`)}
              alt=""
            />
          </div>
          <div className="footer active">
            <div
              className="btn"
              data-conId="8402"
              url={x5ContainWebUrl(
                "https://kaihu.gyzq.com.cn:1443/guoyuan-stkkh-hvue/views/index.html?channel_no=4564#/index",
              )}
            >
              一键开户 立享3重福利
              <div className="tips">（每人可开3个户）</div>
              <div className="tag">把握机会，牛市不错过</div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

const Container = styled.div`
  // 头图
  background-image: url(${require("./images/头图@2x.png")});
  background-repeat: no-repeat;
  background-size: contain;
  background-color: #face81;
  padding: 58px 0px 96px;
  img {
    max-width: 100%;
    vertical-align: middle;
  }
  .line {
    border-top: 1px dashed #e5e5e5;
    margin: 20px;
  }
  .card_box {
    display: flex;
    overflow: scroll;
    .img_wrapper {
      min-width: 120px;
      img + img {
        margin-top: 8px;
      }
    }
    .img_wrapper + .img_wrapper {
      margin-left: 6px;
    }
  }
  .card_box2 {
    display: flex;
    margin-top: 10px;
    justify-content: space-between;
    .img_wrapper + .img_wrapper {
      margin-left: 6px;
    }
  }

  .box {
    border-radius: 12px;
    background: #ffffff;
    box-shadow: inset 0px 1px 3px 0px rgba(255, 255, 255, 0.6);
    border-radius: 0px 0px 19px 19px;
    padding: 0px 0 12px;
    &.box_1 {
      padding: 12px;
    }
    &.box_2 {
      padding: 0 12px 12px;
    }
    .tips {
      text-align: center;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      line-height: 19px;
      text-align: center;
      span {
        color: #ff0000;
      }
      img {
        margin-bottom: 10px;
        width: 107px;
      }
    }
  }
  @keyframes pulse {
    0%,
    100% {
      transform: scale(0.98);
    }
    50% {
      transform: scale(1.05);
    }
  }
  .footer {
    height: 66px;
    // box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.1);
    padding: 0px 3.1vw 10px;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0px;
    z-index: 10;

    &.footer-freeclass-block {
      bottom: 0;
    }
    .tips {
      text-align: center;
      font-size: 10px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 13px;
      margin-top: 0px;
    }
    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      height: 42px;
      background: #f6301e;
      border-radius: 21px;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      position: relative;
      margin-top: 20px;
      transform: scale(1);
      transition: transform 0.5s ease-in-out;
      animation: pulse 1.5s infinite;
    }
  }
  .tag {
    position: absolute;
    font-size: 10px;
    width: 125px;
    height: 18px;
    background: linear-gradient(180deg, #ffee70 0%, #fff7f4 100%);
    border-radius: 9px 9px 9px 0px;
    color: #f6301e;
    line-height: 18px;
    right: 0px;
    top: -14px;
  }
  .kefu {
    position: fixed;
    right: 10px;
    width: 44px;
    bottom: 150px;
  }
`;

export default React.memo(connect((state) => ({
  userId: state.user.userId || '',
}))(App));



// WEBPACK FOOTER //
// ./src/views/activity_172/index.js